import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "form-block text-field" }
const _hoisted_2 = { for: "" }
const _hoisted_3 = {
  key: 0,
  class: "action-button"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("a", { href: "#" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" })
], -1)
const _hoisted_6 = {
  class: "modal-wrap form-edit test",
  style: {"z-index":"9999"}
}
const _hoisted_7 = {
  class: "modal fade",
  id: "editTitle",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_8 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_9 = { class: "modal-content" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, "Edit Title"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_11 = { class: "modal-body" }
const _hoisted_12 = { class: "form-wrap pt-0" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_15 = { class: "modal-footer" }
const _hoisted_16 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}, " Close ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("label", _hoisted_2, _toDisplayString(_ctx.data.title), 1),
      _createVNode("input", {
        type: "text",
        class: "form-control",
        value: _ctx.data.answer
      }, null, 8, ["value"]),
      (_ctx.editStatus)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("a", {
              href: "#",
              "data-toggle": "modal",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTextFieldAdd()))
            }, [
              _hoisted_4
            ]),
            _hoisted_5
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", null, [
                  _createVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.title = $event)),
                      type: "text",
                      class: "form-control",
                      id: "inputPassword",
                      placeholder: "Title Here"
                    }, null, 512), [
                      [_vModelText, _ctx.state.title]
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('click', $event)))
              }, " Add "),
              _hoisted_16
            ])
          ])
        ])
      ])
    ])
  ]))
}